import { useLocation } from 'react-router-dom';

export function useIsDirectorByUrl(): boolean {
  const location = useLocation();
  return location.pathname.includes('direction');
}
